// Shared Razorpay standard-checkout loader (https://checkout.razorpay.com/v1/checkout.js).
// The script is injected on first use — no global tag on any page.

import { pauseScroll, resumeScroll } from "./scroll";

export function loadRazorpay() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(window.Razorpay);
    const existing = document.getElementById("razorpay-checkout-js");
    if (existing) {
      existing.addEventListener("load", () => resolve(window.Razorpay));
      existing.addEventListener("error", () => reject(new Error("Razorpay failed to load")));
      return;
    }
    const s = document.createElement("script");
    s.id = "razorpay-checkout-js";
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(window.Razorpay);
    s.onerror = () => reject(new Error("Razorpay failed to load"));
    document.body.appendChild(s);
  });
}

// Opens Razorpay's standard checkout modal for a server-created order.
// order: { order_id, amount, currency, key_id } from /api/billing/checkout or /api/design-request.
// onSuccess receives { razorpay_order_id, razorpay_payment_id, razorpay_signature }.
export async function openRazorpayCheckout({ order, email, description, onSuccess, onDismiss }) {
  const Razorpay = await loadRazorpay();
  if (!Razorpay || !order?.order_id) throw new Error("Razorpay failed to load");
  // Freeze the page while the modal owns the screen; release on dismiss/success.
  pauseScroll();
  const release = () => resumeScroll();
  const rzp = new Razorpay({
    key: order.key_id,
    amount: order.amount,
    currency: order.currency,
    order_id: order.order_id,
    name: "Grapho",
    description: description || "Design credits",
    prefill: { email: email || "" },
    theme: { color: "#F59E0B" },
    handler: (res) => {
      release();
      onSuccess(res);
    },
    modal: {
      ondismiss: () => {
        release();
        onDismiss && onDismiss();
      },
    },
  });
  rzp.open();
}
